prbJsonp([0],{

/***/ "./client/js/components/ButtonDropdownMenu/ButtonDropdownMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _Throttle = __webpack_require__("./client/js/utilities/Throttle.js");

var _Throttle2 = _interopRequireDefault(_Throttle);

var _SmoothScroll = __webpack_require__("./client/js/utilities/SmoothScroll.js");

var _SmoothScroll2 = _interopRequireDefault(_SmoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Button Dropdown Menu.
 */
var ButtonDropdownMenu = function (_Component) {
  _inherits(ButtonDropdownMenu, _Component);

  /**
   * Start the component
   */
  function ButtonDropdownMenu(config) {
    _classCallCheck(this, ButtonDropdownMenu);

    // Initalizations
    var _this = _possibleConstructorReturn(this, (ButtonDropdownMenu.__proto__ || Object.getPrototypeOf(ButtonDropdownMenu)).call(this, config));

    _this.triggerToggleDropdown();

    // Throttle scroll event for ButtonDropdownMenu
    // Hide the dropdown on scroll
    _this.buttonDropDownThrottle = new _Throttle2.default(_this.setDropdownClosed.bind(_this), 'scroll', document, 50);

    // Link smoothly scrolls user to respective section
    _this.setSmoothScrollLink = new _SmoothScroll2.default('.button-dropdown-menu__list-item a');
    _this.setSmoothScrollLink.init();
    return _this;
  }

  /**
   * Set dropdown to closed state
   */


  _createClass(ButtonDropdownMenu, [{
    key: 'setDropdownClosed',
    value: function setDropdownClosed() {
      if (this.element.classList.contains(this.options.dropdownActiveClass)) {
        this.element.classList.remove(this.options.dropdownActiveClass);
        this.children.button.setAttribute('aria-expanded', 'false');
      }
    }

    /**
     * Trigger to show/hide dropdown
     */

  }, {
    key: 'triggerToggleDropdown',
    value: function triggerToggleDropdown() {
      var _this2 = this;

      this.children.button.addEventListener('click', function () {
        _this2.element.classList.toggle(_this2.options.dropdownActiveClass);
        _this2.children.button.setAttribute('aria-expanded', _this2.isExpanded());
      });
    }

    /**
     * Return aria-expanded state
     * @return {String} 'true' if expanded, 'false' if not
     */

  }, {
    key: 'isExpanded',
    value: function isExpanded() {
      return 'false' === this.children.button.getAttribute('aria-expanded') ? 'true' : 'false';
    }
  }]);

  return ButtonDropdownMenu;
}(_jsComponentFramework.Component);

exports.default = ButtonDropdownMenu;

/***/ }),

/***/ "./client/js/components/ButtonDropdownMenu/buttonDropdownMenuConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonDropdownMenu = __webpack_require__("./client/js/components/ButtonDropdownMenu/ButtonDropdownMenu.js");

var _ButtonDropdownMenu2 = _interopRequireDefault(_ButtonDropdownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonDropdownMenuConfig = {
  name: 'buttonDropdownMenu',
  class: _ButtonDropdownMenu2.default,
  querySelector: {
    button: '.button-dropdown-menu__toggle'
  },
  options: {
    dropdownActiveClass: 'button-dropdown-menu--active'
  }
};

exports.default = buttonDropdownMenuConfig;

/***/ }),

/***/ "./client/js/components/Header/PushNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Push Navigation
 */
var PushNavigation = function (_Component) {
  _inherits(PushNavigation, _Component);

  /**
   * Start the component
   */
  function PushNavigation(config) {
    _classCallCheck(this, PushNavigation);

    // Elements
    var _this = _possibleConstructorReturn(this, (PushNavigation.__proto__ || Object.getPrototypeOf(PushNavigation)).call(this, config));

    _this.pushNav = document.querySelector('.site-pushnav');
    _this.open = document.querySelector('.site-nav__toggle');
    _this.close = document.querySelector('.site-pushnav__toggle');
    _this.page = document.querySelector('#page');

    // Initalizations
    _this.toggleOn();
    _this.toggleOff();
    _this.triggerSubNav();
    return _this;
  }

  /**
   * Toggle state of push navigation to On
   */


  _createClass(PushNavigation, [{
    key: 'toggleOn',
    value: function toggleOn() {
      var _this2 = this;

      this.open.addEventListener('click', function () {
        _this2.pushNav.classList.add(_this2.options.toggleActiveClass);
        _this2.page.classList.add('overlay-active');
      });
    }

    /**
     * Toggle state of push navigation to Off
     */

  }, {
    key: 'toggleOff',
    value: function toggleOff() {
      var _this3 = this;

      this.close.addEventListener('click', function () {
        _this3.pushNav.classList.remove(_this3.options.toggleActiveClass);
        _this3.page.classList.remove('overlay-active');
      });
    }

    /**
     * Trigger push nav sub-navigation
     */

  }, {
    key: 'triggerSubNav',
    value: function triggerSubNav() {
      var _this4 = this;

      Array.prototype.forEach.call(this.children.subNavTrigger, function (el) {
        el.addEventListener('click', function () {
          var parent = el.parentElement;
          var activeClass = _this4.options.subNavActiveClass;

          if (parent.classList.contains(activeClass)) {
            el.parentElement.classList.remove(_this4.options.subNavActiveClass);
            el.setAttribute('aria-expanded', 'false');
          } else {
            el.parentElement.classList.add(_this4.options.subNavActiveClass);
            el.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }
  }]);

  return PushNavigation;
}(_jsComponentFramework.Component);

exports.default = PushNavigation;

/***/ }),

/***/ "./client/js/components/Header/SiteNavigation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _headroom = __webpack_require__("./node_modules/headroom.js/dist/headroom.js");

var _headroom2 = _interopRequireDefault(_headroom);

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Site Navigation
 */
var SiteNavigation = function (_Component) {
  _inherits(SiteNavigation, _Component);

  /**
   * Start the component
   */
  function SiteNavigation(config) {
    _classCallCheck(this, SiteNavigation);

    // Init sticky Nav
    var _this = _possibleConstructorReturn(this, (SiteNavigation.__proto__ || Object.getPrototypeOf(SiteNavigation)).call(this, config));

    if (_this.element.classList.contains(_this.options.stickyClass)) {
      _this.headroom = new _headroom2.default(_this.element, _this.options.headroom);
      _this.headroom.init();
    }

    // Init sub-navigation
    _this.triggerSubNav();
    return _this;
  }

  /**
   * Trigger sub-navigation
   */


  _createClass(SiteNavigation, [{
    key: 'triggerSubNav',
    value: function triggerSubNav() {
      var _this2 = this;

      Array.prototype.forEach.call(this.children.menuItemParents, function (el) {
        el.addEventListener('mouseenter', function (event) {
          event.currentTarget.classList.add(_this2.options.subNavActiveClass);
          event.currentTarget.setAttribute('aria-expanded', 'true');
        });
        el.addEventListener('mouseleave', function (event) {
          event.currentTarget.classList.remove(_this2.options.subNavActiveClass);
          event.currentTarget.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }]);

  return SiteNavigation;
}(_jsComponentFramework.Component);

exports.default = SiteNavigation;

/***/ }),

/***/ "./client/js/components/Header/pushNavConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PushNavigation = __webpack_require__("./client/js/components/Header/PushNavigation.js");

var _PushNavigation2 = _interopRequireDefault(_PushNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pushNavConfig = {
  name: 'pushNav',
  class: _PushNavigation2.default,
  querySelectorAll: {
    subNavTrigger: '.site-pushnav__submenu-trigger'
  },
  options: {
    toggleActiveClass: 'site-pushnav--toggleActivated',
    subNavActiveClass: 'site-pushnav__menu-item--subnav-active'
  }
};

exports.default = pushNavConfig;

/***/ }),

/***/ "./client/js/components/Header/siteNavigationConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteNavigation = __webpack_require__("./client/js/components/Header/SiteNavigation.js");

var _SiteNavigation2 = _interopRequireDefault(_SiteNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavigationConfig = {
  name: 'siteNavigation',
  class: _SiteNavigation2.default,
  querySelectorAll: {
    menuItemParents: '.site-nav__menu-item--has-children'
  },
  options: {
    stickyClass: 'site-nav--sticky',
    subNavActiveClass: 'site-nav__menu-item--subnav-active',
    // Headroom.js config
    // @ref: http://wicky.nillia.ms/headroom.js/
    headroom: {
      // vertical offset in px before element is first unpinned
      offset: 300,
      // scroll tolerance in px before state changes
      tolerance: 5,
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'site-nav',
        // when scrolling down
        pinned: 'site-nav--slidedown',
        // when scrolling up
        unpinned: 'site-nav--slideup',
        // when above offset
        top: 'site-nav--top',
        // when below offset
        notTop: 'site-nav--not-top',
        // when at bottom of scoll area
        bottom: 'site-nav--bottom',
        // when not at bottom of scroll area
        notBottom: 'site-nav--not-bottom'
      }
    }
  }
};

exports.default = siteNavigationConfig;

/***/ }),

/***/ "./client/js/components/LearnMore/LearnMore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating LearnMore.
 */
var LearnMore = function (_Component) {
  _inherits(LearnMore, _Component);

  /**
   * Start the component.
   */
  function LearnMore(config) {
    _classCallCheck(this, LearnMore);

    // Elements
    var _this = _possibleConstructorReturn(this, (LearnMore.__proto__ || Object.getPrototypeOf(LearnMore)).call(this, config));

    _this.learnMoreBox = document.getElementById(_this.options.boxId);
    _this.close = _this.learnMoreBox.querySelector('.landing-learn-more__close');

    // Init
    if (_this.learnMoreBox && _this.close) {
      _this.setShowTrigger();
      _this.setHideTrigger();
    }
    return _this;
  }

  /**
   * Set trigger to show learn more box
   */


  _createClass(LearnMore, [{
    key: 'setShowTrigger',
    value: function setShowTrigger() {
      var _this2 = this;

      this.element.addEventListener('click', function () {
        _this2.show();
      });
    }

    /**
     * Set trigger to hide learn more box
     */

  }, {
    key: 'setHideTrigger',
    value: function setHideTrigger() {
      var _this3 = this;

      this.close.addEventListener('click', function () {
        _this3.hide();
      });
    }

    /**
     * Show learn more box
     */

  }, {
    key: 'show',
    value: function show() {
      this.learnMoreBox.classList.remove(this.options.boxClosedClass);
      this.learnMoreBox.classList.add(this.options.boxActiveClass);
    }

    /**
     * Hide learn more box
     */

  }, {
    key: 'hide',
    value: function hide() {
      this.learnMoreBox.classList.remove(this.options.boxActiveClass);
      this.learnMoreBox.classList.add(this.options.boxClosedClass);
    }
  }]);

  return LearnMore;
}(_jsComponentFramework.Component);

exports.default = LearnMore;

/***/ }),

/***/ "./client/js/components/LearnMore/learnMoreConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LearnMore = __webpack_require__("./client/js/components/LearnMore/LearnMore.js");

var _LearnMore2 = _interopRequireDefault(_LearnMore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var learnMoreConfig = {
  name: 'learnMore',
  class: _LearnMore2.default,
  options: {
    boxId: 'learn_more',
    boxActiveClass: 'landing-learn-more--active',
    boxClosedClass: 'landing-learn-more--closed'
  }
};

exports.default = learnMoreConfig;

/***/ }),

/***/ "./client/js/components/SearchFacets/SearchFacets.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Site Search Facets
 */
var SearchFacets = function (_Component) {
  _inherits(SearchFacets, _Component);

  /**
   * Start the component
   */
  function SearchFacets(config) {
    _classCallCheck(this, SearchFacets);

    // Elements
    var _this = _possibleConstructorReturn(this, (SearchFacets.__proto__ || Object.getPrototypeOf(SearchFacets)).call(this, config));

    _this.form = document.getElementById('prb-search-form');

    // Immediately exit if form does not exist on page
    if (!_this.form) {
      return _possibleConstructorReturn(_this);
    }

    // Facet clicked.
    _this.triggerfacetClicked();

    // Update the orders.
    _this.updateInputOnClick('prb-search-orderby-desc-date', 'order', 'DESC');
    _this.updateInputOnClick('prb-search-orderby-asc-date', 'order', 'ASC');
    _this.updateInputOnClick('prb-search-orderby-relevance', 'orderby', 'post__in');

    _this.setToggleTrigger();
    return _this;
  }

  /**
   * Set toggle trigger to show/hide facets
   */


  _createClass(SearchFacets, [{
    key: 'setToggleTrigger',
    value: function setToggleTrigger() {
      var _this2 = this;

      this.children.button.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.toggle();
      });
    }

    /**
     * Set toggle to show/hide facets
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.children.facets[0]) {
        this.children.facets[0].classList.toggle(this.options.closedClass);
      }
    }

    /**
     * Re-submit the form when a new facet is selected.
     */

  }, {
    key: 'triggerfacetClicked',
    value: function triggerfacetClicked() {
      var form = this.form;
      Array.prototype.forEach.call(this.children.facets, function (facet) {
        facet.addEventListener('click', function () {
          form.submit();
        }, false);
      });
    }

    /**
     * Update an input field with a new value on button click.
     *
     * @param  {string} el    The button selector.
     * @param  {string} field The input field selector.
     * @param  {string} value The new value.
     */

  }, {
    key: 'updateInputOnClick',
    value: function updateInputOnClick(el, field, value) {
      var orderEl = document.getElementById(el);
      var form = this.form;
      if (orderEl) {
        orderEl.addEventListener('click', function (event) {
          event.preventDefault();

          // Get the order input field.
          form.querySelectorAll('input[name="' + field + '"]')[0].value = value;

          if ('order' === field) {
            form.querySelectorAll('input[name="orderby"]')[0].value = 'date';
          }

          // Re-submit the form.
          form.submit();
        }, false);
      }
    }
  }]);

  return SearchFacets;
}(_jsComponentFramework.Component);

exports.default = SearchFacets;

/***/ }),

/***/ "./client/js/components/SearchFacets/searchFacetsConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchFacets = __webpack_require__("./client/js/components/SearchFacets/SearchFacets.js");

var _SearchFacets2 = _interopRequireDefault(_SearchFacets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchFacetsConfig = {
  name: 'siteSearchFacets',
  class: _SearchFacets2.default,
  querySelector: {
    button: '.facets-search__showmore'
  },
  querySelectorAll: {
    facets: '.facets-search__groups'
  },
  options: {
    closedClass: 'facets-search__groups--closed'
  }
};

exports.default = searchFacetsConfig;

/***/ }),

/***/ "./client/js/components/SiteSearch/SiteSearch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Site Header Search
 */
var SiteSearch = function (_Component) {
  _inherits(SiteSearch, _Component);

  /**
   * Start the component
   */
  function SiteSearch(config) {
    _classCallCheck(this, SiteSearch);

    // Elements
    var _this = _possibleConstructorReturn(this, (SiteSearch.__proto__ || Object.getPrototypeOf(SiteSearch)).call(this, config));

    _this.page = document.getElementById('page');
    _this.trigger = document.querySelector('.site-nav__search-trigger');

    // Initalizations
    _this.triggerShowSearch();
    _this.triggerHideSearch();
    return _this;
  }

  /**
   * Trigger to show search field
   */


  _createClass(SiteSearch, [{
    key: 'triggerShowSearch',
    value: function triggerShowSearch() {
      var _this2 = this;

      this.trigger.addEventListener('click', function () {
        _this2.page.classList.add(_this2.options.overlayActiveClass);
        _this2.element.classList.add(_this2.options.searchActiveClass);
        _this2.children.searchField.focus();
      });
    }

    /**
     * Trigger to hide search field
     */

  }, {
    key: 'triggerHideSearch',
    value: function triggerHideSearch() {
      var _this3 = this;

      this.children.close.addEventListener('click', function () {
        _this3.page.classList.remove(_this3.options.overlayActiveClass);
        _this3.element.classList.remove(_this3.options.searchActiveClass);
        _this3.children.searchField.blur();
      });
    }
  }]);

  return SiteSearch;
}(_jsComponentFramework.Component);

exports.default = SiteSearch;

/***/ }),

/***/ "./client/js/components/SiteSearch/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteSearch = __webpack_require__("./client/js/components/SiteSearch/SiteSearch.js");

var _SiteSearch2 = _interopRequireDefault(_SiteSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchConfig = {
  name: 'siteSearch',
  class: _SiteSearch2.default,
  querySelector: {
    searchField: '.search-form__search-field',
    close: '.search-form__close',
    button: '.facets-search__showmore'
  },
  options: {
    overlayActiveClass: 'overlay-active',
    searchActiveClass: 'search-form--active'
  }
};

exports.default = searchConfig;

/***/ }),

/***/ "./client/js/site/site.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectFitImages = __webpack_require__("./node_modules/object-fit-images/dist/ofi.common-js.js");

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _siteNavigationConfig = __webpack_require__("./client/js/components/Header/siteNavigationConfig.js");

var _siteNavigationConfig2 = _interopRequireDefault(_siteNavigationConfig);

var _pushNavConfig = __webpack_require__("./client/js/components/Header/pushNavConfig.js");

var _pushNavConfig2 = _interopRequireDefault(_pushNavConfig);

var _SiteSearch = __webpack_require__("./client/js/components/SiteSearch/index.js");

var _SiteSearch2 = _interopRequireDefault(_SiteSearch);

var _learnMoreConfig = __webpack_require__("./client/js/components/LearnMore/learnMoreConfig.js");

var _learnMoreConfig2 = _interopRequireDefault(_learnMoreConfig);

var _buttonDropdownMenuConfig = __webpack_require__("./client/js/components/ButtonDropdownMenu/buttonDropdownMenuConfig.js");

var _buttonDropdownMenuConfig2 = _interopRequireDefault(_buttonDropdownMenuConfig);

var _searchFacetsConfig = __webpack_require__("./client/js/components/SearchFacets/searchFacetsConfig.js");

var _searchFacetsConfig2 = _interopRequireDefault(_searchFacetsConfig);

__webpack_require__("./client/scss/site/loader.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set up component manager
var manager = new _jsComponentFramework.ComponentManager('prb-2017');

// Import SCSS


// Components
/**
 * Core global JS.
 */


var configs = [_siteNavigationConfig2.default, _pushNavConfig2.default, _SiteSearch2.default, _buttonDropdownMenuConfig2.default, _learnMoreConfig2.default, _searchFacetsConfig2.default];

// Initialize components
document.addEventListener('DOMContentLoaded', function () {
  manager.initComponents(configs);
  (0, _objectFitImages2.default)();
});

if (false) {
  module.hot.accept();
  manager.initComponents(configs);
}

/***/ }),

/***/ "./client/scss/site/loader.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/object-fit-images/dist/ofi.common-js.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.3 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./client/js/site/site.js");


/***/ })

},[6]);


// WEBPACK FOOTER //
// js/site.46d7bf5.bundle.min.js